const getServerURL = () => {
    const hostname = window.location.hostname;
    if (hostname === 'localhost') { return 'http://localhost/'; }
    const isLocalNetwork = hostname.startsWith('172.') || hostname.startsWith('192.') || hostname.startsWith('10.');
    return isLocalNetwork ? 'http://172.16.168.240/' : 'http://102.218.58.66/';
  };
const SVR = getServerURL();
//const SVR = 'http://102.218.58.66/'
export const APACHE_URL             = SVR + "hwa_api/";
export const BILLINGSERVERDATA      = SVR + "hwa_billing/listBills.php"
export const GIS                    = SVR + "gis_api/"
export const CALLCENTEREXTS         = SVR + "ucm/getExtensions.php"
export const CALLCENTERCDR          = SVR + "ucm/getCDR.php"
export const CALLREC                = SVR + "ucm/getFile.php"
export const HRMIS                  = "HWAIS";
export const HRMISPass              = "0IpPon9fDIZpCPYCe0W318VZ9dOIvqcAzcIkOh23qYk="; 
export const COMPANY                = "Hargeisa Water Agency"

/*LOGIN, REGISTER, PROFILE, RESET PASSWORD*/ 
export const NOTIFICATIONS          = APACHE_URL+"notifications.php"
export const USERS                  = APACHE_URL+"users.php"
export const USERSFILTER            = APACHE_URL+"usersFilter.php"
export const USERROLES              = APACHE_URL+"user_roles.php"
export const POST_LOGIN             = APACHE_URL+"auth_login.php"
export const POST_PASSWORD_FORGET   = APACHE_URL+"auth_reset_password.php"
export const CHANGEPASSWORD         = APACHE_URL+"auth_change_password.php"
export const POST_EDIT_PROFILE      = APACHE_URL+"auth_edit_profile.php"

export const REGIONS                = APACHE_URL+"mmRegions.php"
export const CLUSTERS               = APACHE_URL+"mmClusters.php"
export const AREAS                  = APACHE_URL+"mmAreas.php"
export const SCHEME                 = APACHE_URL+"mmScheme.php"
export const FACILITIES             = APACHE_URL+"mmFacilities.php"
export const CORDINATES             = APACHE_URL+"mmCordinates.php"
export const FACILITYSTATION        = APACHE_URL+"mmFacilityLocations.php"
export const EQUIPMENT              = APACHE_URL+"mmEquipment.php"
export const TYPES                  = APACHE_URL+"mmAssetTypes.php"
export const TREE                   = APACHE_URL+"mmTreeData.php"
export const ASSETS                 = APACHE_URL+"mmAssets.php"
export const ASSETSFILTER           = APACHE_URL+"mmAssetFilter.php"
export const ASSETTYPES             = APACHE_URL+"mmAssetTypes.php"
export const ASSETCATEGORIES        = APACHE_URL+"mmAssetCategories.php"

export const PARAMETERS             = APACHE_URL+"wqParameters.php"
export const SAMPLINGPOINTS         = APACHE_URL+"wqSamplingPoints.php"
export const WQDATA                 = APACHE_URL+"wqData.php"
export const WQDATA1                = APACHE_URL+"wqData1.php"
export const WQSAMPLES              = APACHE_URL+"wqSamples.php"
export const WQSAMPLERLINE          = APACHE_URL+"wqSampleLine.php"
export const WQREPORT               = APACHE_URL+"wqReport.php"
export const WQREPORTDATA           = APACHE_URL+"wqReportData.php"
export const WQREPORTDATA2          = APACHE_URL+"wqReportData2.php"

export const DASHNOTIFICATIONS      = APACHE_URL+"dashNotifications.php"
export const DASHASSETS             = APACHE_URL+"dashAssets.php"
export const DASHGAUGES             = APACHE_URL+"dashGauges.php"
export const DASHMTCE               = APACHE_URL+"dashMaintenance.php"
export const WTYPES                 = APACHE_URL+"mmWorkTypes.php"
export const WREQUESTS              = APACHE_URL+"mmWorkRequests.php"
export const WREQUESTSFILTER        = APACHE_URL+"mmWorkRequestsFilter.php"
export const WORDERS                = APACHE_URL+"mmWorkOrders.php"
export const WORDERSFILTER          = APACHE_URL+"mmWorkOrdersFilter.php"
export const WORDERSTAFF            = APACHE_URL+"mmWorkOrderStaff.php"
export const SPARES                 = APACHE_URL+"mmWorkSpares.php"
export const WUPDATE                = APACHE_URL+"mmWorkUpdates.php"
export const WREPORT                = APACHE_URL+"mmWorkReports.php"
export const JOBCARD                = APACHE_URL+"mmJobcard.php"
export const PPMPERIOD              = APACHE_URL+"mmPPMPeriod.php"
export const PPMSCHEDULE            = APACHE_URL+"mmPPM.php"
export const PPMWORKORDER           = APACHE_URL+"PPMWorkOrder.php"
export const STAFF                  = APACHE_URL+"staff.php"
export const PRINTCORRECTIVE        = APACHE_URL+"mmPrintCorrective.php"
export const PRINTPPM               = APACHE_URL+"mmPrintPPM.php"
export const CREATEPPMWO            = APACHE_URL+"mmPPMCreateWO.php"
export const SENDAPPROVALREQUEST    = APACHE_URL+"approvals.php"

export const FILTERBOREHOLES        = APACHE_URL+"mmBoreholesFilter.php"
export const GEOCOORDINATES         = APACHE_URL+"mmGeoCoordinates.php"
export const MMDELETE               = APACHE_URL+"mmDelete.php"

export const DASHCOMPLAINTS         = APACHE_URL+"dashComplaints.php"
export const DASHCOMPLAINTSDISTRICTS= APACHE_URL+"dashComplaintsByDistricts.php"
export const DASHTOPCOMPLAINTS      = APACHE_URL+"dashComplaintCategories.php"
export const DASHCOMPLAINTSTATUS    = APACHE_URL+"dashComplaintStatus.php"
export const DASHPAYMENTS           = APACHE_URL+"dashPayments.php"
export const DASHPAYMENTDISTRICTS   = APACHE_URL+"dashPaymentDistricts.php"
export const COMPLAINTCATEGORIES    = APACHE_URL+"ccCategories.php"
export const COMPLAINTS             = APACHE_URL+"ccComplaint.php"
export const COMPLAINTFILTER        = APACHE_URL+"ccComplaintFilter.php"
export const TERRITORIES            = APACHE_URL+"ccTerritories.php"
export const ASSIGNCOMPLAINT        = APACHE_URL+"ccComplaintAssign.php"
export const DELETECOMPLAINT        = APACHE_URL+"ccDeleteComplaint.php"
export const CLOSECOMPLAINT         = APACHE_URL+"ccComplaintClose.php"
export const HANDLERS               = APACHE_URL+"ccHandler.php"
export const DEPTS                  = APACHE_URL+"ccDepts.php"
export const SECTIONS                  = APACHE_URL+"ccDepts.php"
export const SEARCH                 = APACHE_URL+"search.php"
export const MESSAGES               = APACHE_URL+"ccMessages.php"
export const BRANCHES               = APACHE_URL+"ccBranches.php"
export const UPLOADSMSFILE          = APACHE_URL+"ccReminders.php"
export const SENDSMS                = APACHE_URL+"ccSendReminders.php"
export const DELETESMS              = APACHE_URL+"ccRemindersDelete.php"
export const USERLOGS               = APACHE_URL+"ccUserLogs.php"
export const COMPLAINTREPORT        = APACHE_URL+"ccComplaintReport.php"
export const CHAT                   = APACHE_URL+"ccChat.php"
export const ATTACHDOCUMENT         = APACHE_URL+"ccAttachDocument.php"

export const BILLPAYMENTS           = APACHE_URL+"ccBillPayments.php"
export const BILLPAYMENTSREPORT     = APACHE_URL+"ccBillPaymentsReport.php"
export const BILLUPDATE             = APACHE_URL+"ccBillPaymentUpdate.php"
export const BILLADD                = APACHE_URL+"ccBillPaymentNew.php"

export const DASHPRODUCTION         = APACHE_URL+"dashProduction.php"
export const DASHPRODUCTIONDAILY    = APACHE_URL+"dashProductionDaily.php"
export const CHEMICALS              = APACHE_URL+"ppChemicals.php"
export const PRODUCTION             = APACHE_URL+"ppProduction.php"
export const PRODUCTIONFILTER       = APACHE_URL+"ppProductionFilter.php"
export const PRODUCTIONREPORT       = APACHE_URL+"ppProductionReport.php"
export const PRODUCTIONSTAGELINE    = APACHE_URL+"ppProductionStage.php"
export const PRODUCTIONCHEMICALS    = APACHE_URL+"ppProductionChemicals.php"
export const PRODUCTIONENERGY       = APACHE_URL+"ppProductionEnergy.php"

export const APPROVERS              = APACHE_URL+"approvers.php"
export const APPROVAL               = APACHE_URL+"approval.php"
export const TITLES                 = APACHE_URL+"ppTitles.php"

export const WAREHOUSES             = APACHE_URL+"invWarehouses.php"
export const SUPPLIERS              = APACHE_URL+"invSuppliers.php"
export const SUPPLIERFILTER         = APACHE_URL+"invSuppliersFilter.php"
export const SUPPLIERCATEGORIES     = APACHE_URL+"invSupplierCategories.php"
export const INVENTORY              = APACHE_URL+"invInventory.php"
export const ITEMCATEGORIES         = APACHE_URL+"invItemCategories.php"
export const INVENTORYFILTER        = APACHE_URL+"invInventoryFilter.php"
export const ORDERS                 = APACHE_URL+"invOrders.php"
export const STOCKMOVEMENT          = APACHE_URL+"invStockMovement.php"
export const STOCKMOVEMENTFILTER    = APACHE_URL+"invStockMovementFilter.php"

export const HRDASHEMPLOYEES        = APACHE_URL+"dashHRStaff.php"
export const HRDASHGAUGES           = APACHE_URL+"dashHRGauges.php"
export const HRDASHLEAVE            = APACHE_URL+"dashLeave.php"

export const HREMPLOYEES            = APACHE_URL+"hrEmployees.php"
export const HREMPLOYEESFILTER      = APACHE_URL+"hrEmployeesFilter.php"
export const HREMPLOYEESCONTRACTLINE= APACHE_URL+"hrEmployeeContractLine.php"
export const HREMPLOYEEDEPLINE      = APACHE_URL+"hrEmployeeDependantLine.php"
export const HREMPLOYEEEDUCLINE     = APACHE_URL+"hrEmployeeEducationLine.php"
export const HREMPLOYEEEXPLINE      = APACHE_URL+"hrEmployeeExperienceLine.php"
export const HREMPLOYEEHISTLINE     = APACHE_URL+"hrEmployeeHistoryLine.php"
export const HREMPLOYEELANGLINE     = APACHE_URL+"hrEmployeeLanguageLine.php"
export const HREMPLOYEELICELINE     = APACHE_URL+"hrEmployeeLicenceLine.php"
export const HREMPLOYEEPASSPORTLINE = APACHE_URL+"hrEmployeePassportLine.php"
export const HREMPLOYEEMEMBERLINE   = APACHE_URL+"hrEmployeeMembershipLine.php"
export const HREMPLOYEESKILLLINE    = APACHE_URL+"hrEmployeeSkillLine.php"
export const HREMPLOYEEPAYLINE      = APACHE_URL+"hrEmployeePayScaleLine.php"
export const HREMPLOYEEASSETLINE    = APACHE_URL+"hrEmployeeEquipmentLine.php"
export const HRLOCATIONS            = APACHE_URL+"hrLocations.php"
export const HREMPLOYEEFILES        = APACHE_URL+"hrEmployeeFiles.php"
export const HRORGANOGRAM           = APACHE_URL+"hrOrganogram.php"

export const HRPAYSCALES            = APACHE_URL+"hrPayScales.php"
export const HRPAYADJUSTMENT        = APACHE_URL+"hrPayAdjustments.php"

export const HRPAYROLL              = APACHE_URL+"hrPayroll.php"
export const HRPAYROLLLINE          = APACHE_URL+"hrPayrollLines.php"
export const HRPAYROLLLINEADJUST    = APACHE_URL+"hrPayrollLineAdjustments.php"
export const HRPRINTPAYSLIPS        = APACHE_URL+"hrPayrollPrintPayslip.php"
export const HRPRINTPAYROLL         = APACHE_URL+"hrPayrollPrint.php"
export const HRPRINTPAYROLLPDF      = APACHE_URL+"hrPayrollPrintPDF.php"

export const HRPAYEMPLOYEELOANS     = APACHE_URL+"hrPayEmployeeLoans.php"
export const HRPAYEMPLOYEELOANREPAY = APACHE_URL+"hrPayEmployeeLoanRepayments.php"

export const HRLEAVEPLAN            = APACHE_URL+"hrLeavePlans.php"
export const HRLEAVEPLANFILTER      = APACHE_URL+"hrLeavePlansFilter.php"
export const HRLEAVE                = APACHE_URL+"hrLeave.php"
export const HRLEAVEFILTER          = APACHE_URL+"hrLeaveFilter.php"
export const HRLEAVEFORM            = APACHE_URL+"hrLeaveForm.php"

export const HRPAGRADES             = APACHE_URL+"hrAppraisalGrades.php"
export const HRPAPERIODS            = APACHE_URL+"hrAppraisalPeriods.php"
export const HRPERFORMANCEAGG       = APACHE_URL+"hrIPAs.php"
export const HRIPERFORMANCEAGGLINES = APACHE_URL+"hrIPALines.php"
export const HRAPPRAISALS           = APACHE_URL+"hrAppraisals.php"
export const HRAPPRAISALLINES       = APACHE_URL+"hrAppraisalLines.php"
export const HRIPA2APPRAISAL        = APACHE_URL+"hrAppraisalFromIPA.php"

export const HRATTENDANCE           = APACHE_URL+"hrAttendance.php"
export const HRATTENDANCEFILTER     = APACHE_URL+"hrAttendanceFilter.php"

export const HRDISCIPLINARYSETUP    = APACHE_URL+"hrDisciplinarySettings.php"
export const HRDISCIPLINARYCASES    = APACHE_URL+"hrDisciplinaryCases.php"
export const HRDISCIPLINARYSEND2HR  = APACHE_URL+"hrDisciplinarySendToHR.php"
export const HRDISCIPLINARYWITHDRAWCASE  = APACHE_URL+"hrDisciplinaryWithdrawCase.php"


















